import React from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import DateRange from "@material-ui/icons/DateRange";
import TrendingUp from "@material-ui/icons/TrendingUp";
import AddBox from "@material-ui/icons/AddBox";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";

//import { bugs, website, server } from "variables/general.js";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts.js";

import performer from "assets/img/performer.png";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Accessibility />
              </CardIcon>
              <p className={classes.cardCategory}>Connections</p>
              <h3 className={classes.cardTitle}>+245</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                This Month
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <AddBox />
              </CardIcon>
              <p className={classes.cardCategory}>New/Port</p>
              <h3 className={classes.cardTitle}>+50</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                This Month
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <TrendingUp />
              </CardIcon>
              <p className={classes.cardCategory}>Upgrade</p>
              <h3 className={classes.cardTitle}>+195</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                This Month
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="success">
              <h4 className={classes.cardTitleWhite}>Top Performers</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={6} sm={4}>
                  <Card>
                    <CardBody>
                      <img src={performer} alt="performer" style={{width:"100%"}} />
                    </CardBody>
                  </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                  <Card>
                    <CardBody>
                      <img src={performer} alt="performer" style={{width:"100%"}} />
                    </CardBody>
                  </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                  <Card>
                    <CardBody>
                      <img src={performer} alt="performer" style={{width:"100%"}} />
                    </CardBody>
                  </Card>
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter chart>
              <div style={{textAlign:"center", width:"100%"}}>
                <Button
                    color="info"
                    href="/admin/team-overview"
                >
                  View Full Team
                </Button>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={dailySalesChart.data}
                type="Line"
                options={dailySalesChart.options}
                listener={dailySalesChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Daily Sales</h4>
              <p className={classes.cardCategory}>
                <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "}
                increase in today sales.
              </p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> updated 4 minutes ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Total Connection</h4>
              <p className={classes.cardCategory}>Last Year</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> 2019
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="danger">
              <ChartistGraph
                className="ct-chart"
                data={completedTasksChart.data}
                type="Line"
                options={completedTasksChart.options}
                listener={completedTasksChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Completed Application</h4>
              <p className={classes.cardCategory}>Last 10 days</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> updated till yesterday
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="info">
              <h4 className={classes.cardTitleWhite}>Recently Updated Applications</h4>
            </CardHeader>
            <CardBody>
              <Table
                  tableHeaderColor="info"
                  tableHead={["Application", "Status", "Last Activity"]}
                  tableData={[
                    ["Awesome Security Services", "Ready For Submission", "24.07.2020"],
                    ["Foobar Pty Ltd.", "Pending Signature", "23.07.2020"],
                    ["Astracorp Australia Pty Ltd", "Not Completed", "23.07.2020"],
                    ["V96 & Company Pty Ltd", "Pending Signature", "20.07.2020"]
                  ]}
              />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="success">
              <h4 className={classes.cardTitleWhite}>Completed Applications</h4>
            </CardHeader>
            <CardBody>
              <Table
                  tableHeaderColor="success"
                  tableHead={["Application", "Status", "Last Activity"]}
                  tableData={[
                    ["ABC Services", "Submitted", "22.07.2020"],
                    ["Variety Store Pty Ltd.", "Submitted", "19.07.2020"],
                    ["Consilium Metal Works Ltd", "Submitted", "18.07.2020"],
                    ["XYZ Store Ltd", "Submitted", "15.07.2020"]
                  ]}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
